export default {
  // Generic actions
  actions: {
    cancel: "Отказ",
    close: "Затваряне",
    save: "Запазване",
    apply: "Прилагане",
    confirm: "Потвърждаване",
    delete: "Изтриване",
    refresh: "Обновяване",
  },

  // Generic messages
  messages: {
    loading: "Зареждане...",
    loading_info: "Зареждане на информация...",
    saving: "Записване на промените...",
    deleting: "Изтриване...",
    noData: "Няма налични данни",
    error: "Възникна грешка",
  },

  // Common button patterns
  buttons: {
    clearAll: "Изчистване на всички",
    selectAll: "Избиране на всички",
    deselectAll: "Премахване избора на всички",
  },

  titles: {
    sample_info: "Информация за проба: {barcode}",
  },

  //
  // Sample Info Dialog
  //
  sample_info: {
    tabs: {
      basic_info: "Основна информация",
      instruments: "Апарати",
      results_sets: "Серии от резултати",
    },

    results_sets_table: {
      group_name: "Серия",
    },
  },
};
